<script setup lang="ts">
import type { ImgModel } from '@convatec/180medical-website/types/image'
import type { HTMLAttributes } from 'vue'

interface Props {
  as?: string
  class?: HTMLAttributes['class']
  detectScroll?: boolean
  headerLogo: ImgModel
}

const props = withDefaults(defineProps<Props>(), {
  as: 'header',
})

const { cmerge } = useCvtHelpers()
</script>

<template>
  <component
    :is="props.as"
    :class="cmerge(
      props.class,
      'med-header sticky top-0 z-10',
    )"
  >
    <div class="absolute top-1/2 left-7.5 2xl:left-7.5 3xl:left-20 -translate-y-1/2 z-20">
      <NuxtLink
        to="/"
        class=""
        aria-label="Home - 180 Medical"
      >
        <NuxtImg
          provider="fastlyAprimo"
          :src="props.headerLogo.imageUrl"
          :alt="props.headerLogo.imageAltText"
          :width="props.headerLogo.width ?? 176"
          :height="props.headerLogo.height ?? 96"
          class="w-24.5 xl:w-27.5 2xl:w-35 3xl:w-44 h-auto"
        />
      </NuxtLink>
    </div>
    <slot name="upper" />
    <LazyLayoutNavHeader>
      <template #mobileNav>
        <slot name="mobileNav" />
      </template>
      <template #mainNav>
        <slot name="mainNav" />
      </template>
      <template #actions>
        <slot name="actions" />
      </template>
    </LazyLayoutNavHeader>
  </component>
</template>
